export default "__VITE_ASSET__CO307CC6__"